export default __webpack_public_path__ + "static/media/wadapp2-min.21534b1a.png";